'use strict'
/**
 * domainContext.js — Contrato CICATRIZ #1 (MACRO 1 · Ola 1).
 *
 * EL BUG QUE TIPA: contextualize() devolvía string, stateLine() leía
 * .context_text → undefined → fallback "Aún aprendiendo de ti" para
 * siempre, enmascarando el cable roto (fix d256657).
 *
 * PRODUCTOR: src/engine/domains/domainContextualizer.js · contextualize()
 *            src/routes/domainsRoutes.js · GET /api/domains/c4/:userId/explore
 * CONSUMIDOR: src/components/dominios-v2/useDomains.js → utils.js stateLine()
 */

const { z } = require('./z')

/**
 * fenotypic_context: SIEMPRE objeto { context_text } o null.
 * String directa = el contrato roto histórico → debe fallar ruidoso.
 */
const FenotypicContextSchema = z
  .object({
    context_text: z.string().min(1),
    headline: z.string().optional(),
  })
  .nullable()

/** Un dominio del ranking del explorer (domainRanker → scored entry). */
const RankedDomainSchema = z
  .object({
    domainId: z.string().min(1),
    score: z.number(),
    fenotypic_context: FenotypicContextSchema,
    // domain (taxonomía completa) y breakdown viajan pero la UI no depende
    // de su shape interno — passthrough deliberado
  })
  .passthrough()

/** Respuesta completa de GET /api/domains/c4/:userId/explore */
const ExploreResponseSchema = z
  .object({
    fenotype: z.string(),
    limiting_domain: z.string().nullable(),
    all_domains: z.array(RankedDomainSchema),
  })
  .passthrough()

module.exports = { FenotypicContextSchema, RankedDomainSchema, ExploreResponseSchema }
